import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-scheduler-dialog',
  templateUrl: './scheduler-dialog.component.html',
  styleUrls: ['./scheduler-dialog.component.scss']
})
export class SchedulerDialogComponent implements OnInit {

  /****************** Variable declaration ******************/
  startDate: any;
  endDate: any;
  repeatDay: any;
  repeatValue: any;

  /**pre-defined values for the dropdown */
  repeatOptions = [
    { value: 'Day', viewValue: 'Day', days: 1 },
    { value: 'Week', viewValue: 'Week', days: 7 },
    { value: 'Month', viewValue: 'Month', days: 30 },
    { value: 'Year', viewValue: 'Year', days: 365 },
  ];

  /****************** Input and Output decorators ******************/
  @Output() scheduleData: EventEmitter<any> = new EventEmitter<any>(); // Define an output event emitter

  /**
   * Constructor
   * @param dialogRef 
   */
  constructor(public dialogRef: MatDialogRef<SchedulerDialogComponent>) { }

  /**ngOnInit */
  ngOnInit(): void { }

  /**onNoClick function is used to invoke the dialog box */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * onSave function is used for saving the dialog content and forward that data
   */
  onSave() {
    const scheduleData = {
      repeatDay: this.repeatDay,
      repeatValue: this.repeatValue
    };
    this.dialogRef.close(scheduleData);
  }
}
